import React from 'react'
import { Link } from 'react-router-dom'

function Bicycle() {
  return (
    <div>
    <div className="subheader normal-bg section-padding">
      <div className="container">
        <div className="row">
          <div className="col-12 text-left">
            <h1 className="text-custom-white">Bicycle</h1>
            <ul className="custom-flex">
              <li className="fw-500"> <Link to="/" className="text-custom-white">Home</Link> </li>
              <li className="active fw-500"> Bicycle </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    {/* <!-- End Subheader --> 
    <!-- Start Blog --> */}
    <section className="section-padding">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="listing-top-heading mb-xl-20">
              <h6 className="no-margin text-custom-black">Showing 8 Results</h6>
              <div className="sort-by"> <span className="text-custom-black fs-14 fw-600">Sort by</span>
                <div className="group-form">
                  <select className="form-control form-control-custom custom-select">
                    <option>A to Z</option>
                    <option>Z to A</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className=" col-lg-4 col-md-6">
            <div className="bicycle-grid mb-xl-30">
              <div className="bicycle-grid-wrapper bicycle-grid bx-wrapper">
                <div className="image-sec animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/bicycle/cy-2.jpg" className="full-width" alt="img"/> </Link> </div>
                <div className="bicycle-grid-caption padding-20 bg-custom-white p-relative">
                  <h4 className="title fs-16"><Link to="#" className="text-custom-black">Road Bicycle<small className="text-light-dark">Per Day</small></Link></h4>
                  <span className="price"><small>From</small>$18</span>
                  <div className="action"> <Link className="btn-second btn-small" to="#">View</Link> <Link className="btn-first btn-submit" to="#">Book</Link> </div>
                </div>
              </div>
            </div>
          </div>
          <div className=" col-lg-4 col-md-6">
            <div className="bicycle-grid mb-xl-30">
              <div className="bicycle-grid-wrapper bicycle-grid bx-wrapper">
                <div className="image-sec animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/bicycle/cy-3.jpg" className="full-width" alt="img"/> </Link> </div>
                <div className="bicycle-grid-caption padding-20 bg-custom-white p-relative">
                  <h4 className="title fs-16"><Link to="#" className="text-custom-black">Road Bicycle<small className="text-light-dark">2 Day</small></Link></h4>
                  <span className="price"><small>From</small>$58</span>
                  <div className="action"> <Link className="btn-second btn-small" to="#">View</Link> <Link className="btn-first btn-submit" to="#">Book</Link> </div>
                </div>
              </div>
            </div>
          </div>
          <div className=" col-lg-4 col-md-6">
            <div className="bicycle-grid mb-xl-30">
              <div className="bicycle-grid-wrapper bicycle-grid bx-wrapper">
                <div className="image-sec animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/bicycle/cy-2.jpg" className="full-width" alt="img"/> </Link> </div>
                <div className="bicycle-grid-caption padding-20 bg-custom-white p-relative">
                  <h4 className="title fs-16"><Link to="#" className="text-custom-black">Road Bicycle<small className="text-light-dark">Per Day</small></Link></h4>
                  <span className="price"><small>From</small>$28</span>
                  <div className="action"> <Link className="btn-second btn-small" to="#">View</Link> <Link className="btn-first btn-submit" to="#">Book</Link> </div>
                </div>
              </div>
            </div>
          </div>
          <div className=" col-lg-4 col-md-6">
            <div className="bicycle-grid mb-xl-30">
              <div className="bicycle-grid-wrapper bicycle-grid bx-wrapper">
                <div className="image-sec animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/bicycle/cy-3.jpg" className="full-width" alt="img"/> </Link> </div>
                <div className="bicycle-grid-caption padding-20 bg-custom-white p-relative">
                  <h4 className="title fs-16"><Link to="#" className="text-custom-black">Road Bicycle<small className="text-light-dark">Per Day</small></Link></h4>
                  <span className="price"><small>From</small>$58</span>
                  <div className="action"> <Link className="btn-second btn-small" to="#">View</Link> <Link className="btn-first btn-submit" to="#">Book</Link> </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="bicycle-grid mb-xl-30">
              <div className="bicycle-grid-wrapper bicycle-grid bx-wrapper">
                <div className="image-sec animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/bicycle/cy-2.jpg" className="full-width" alt="img"/> </Link> </div>
                <div className="bicycle-grid-caption padding-20 bg-custom-white p-relative">
                  <h4 className="title fs-16"><Link to="#" className="text-custom-black">Road Bicycle<small className="text-light-dark">Per Day</small></Link></h4>
                  <span className="price"><small>From</small>$58</span>
                  <div className="action"> <Link className="btn-second btn-small" to="#">View</Link> <Link className="btn-first btn-submit" to="#">Book</Link> </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="bicycle-grid mb-xl-30">
              <div className="bicycle-grid-wrapper bicycle-grid bx-wrapper">
                <div className="image-sec animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/bicycle/cy-3.jpg" className="full-width" alt="img"/> </Link> </div>
                <div className="bicycle-grid-caption padding-20 bg-custom-white p-relative">
                  <h4 className="title fs-16"><Link to="#" className="text-custom-black">Road Bicycle<small className="text-light-dark">Per Day</small></Link></h4>
                  <span className="price"><small>From</small>$158</span>
                  <div className="action"> <Link className="btn-second btn-small" to="#">View</Link> <Link className="btn-first btn-submit" to="#">Book</Link> </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="bicycle-grid mb-xl-30">
              <div className="bicycle-grid-wrapper bicycle-grid bx-wrapper">
                <div className="image-sec animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/bicycle/cy-2.jpg" className="full-width" alt="img"/> </Link> </div>
                <div className="bicycle-grid-caption padding-20 bg-custom-white p-relative">
                  <h4 className="title fs-16"><Link to="#" className="text-custom-black">Road Bicycle<small className="text-light-dark">Per Day</small></Link></h4>
                  <span className="price"><small>From</small>$58</span>
                  <div className="action"> <Link className="btn-second btn-small" to="#">View</Link> <Link className="btn-first btn-submit" to="#">Book</Link> </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="bicycle-grid mb-xl-30">
              <div className="bicycle-grid-wrapper bicycle-grid bx-wrapper">
                <div className="image-sec animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/bicycle/cy-3.jpg" className="full-width" alt="img"/> </Link> </div>
                <div className="bicycle-grid-caption padding-20 bg-custom-white p-relative">
                  <h4 className="title fs-16"><Link to="#" className="text-custom-black">Road Bicycle<small className="text-light-dark">Per Day</small></Link></h4>
                  <span className="price"><small>From</small>$58</span>
                  <div className="action"> <Link className="btn-second btn-small" to="#">View</Link> <Link className="btn-first btn-submit" to="#">Book</Link> </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="bicycle-grid mb-md-30">
              <div className="bicycle-grid-wrapper bicycle-grid bx-wrapper">
                <div className="image-sec animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/bicycle/cy-2.jpg" className="full-width" alt="img"/> </Link> </div>
                <div className="bicycle-grid-caption padding-20 bg-custom-white p-relative">
                  <h4 className="title fs-16"><Link to="#" className="text-custom-black">Road Bicycle<small className="text-light-dark">Per Day</small></Link></h4>
                  <span className="price"><small>From</small>$58</span>
                  <div className="action"> <Link className="btn-second btn-small" to="#">View</Link> <Link className="btn-first btn-submit" to="#">Book</Link> </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="bicycle-grid mb-xl-30">
              <div className="bicycle-grid-wrapper bicycle-grid bx-wrapper">
                <div className="image-sec animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/bicycle/cy-3.jpg" className="full-width" alt="img"/> </Link> </div>
                <div className="bicycle-grid-caption padding-20 bg-custom-white p-relative">
                  <h4 className="title fs-16"><Link to="#" className="text-custom-black">Road Bicycle<small className="text-light-dark">Per Day</small></Link></h4>
                  <span className="price"><small>From</small>$58</span>
                  <div className="action"> <Link className="btn-second btn-small" to="#">View</Link> <Link className="btn-first btn-submit" to="#">Book</Link> </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="bicycle-grid mb-xl-30">
              <div className="bicycle-grid-wrapper bicycle-grid bx-wrapper">
                <div className="image-sec animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/bicycle/cy-2.jpg" className="full-width" alt="img"/> </Link> </div>
                <div className="bicycle-grid-caption padding-20 bg-custom-white p-relative">
                  <h4 className="title fs-16"><Link to="#" className="text-custom-black">Road Bicycle<small className="text-light-dark">Per Day</small></Link></h4>
                  <span className="price"><small>From</small>$58</span>
                  <div className="action"> <Link className="btn-second btn-small" to="#">View</Link> <Link className="btn-first btn-submit" to="#">Book</Link> </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="bicycle-grid mb-xl-30">
              <div className="bicycle-grid-wrapper bicycle-grid bx-wrapper">
                <div className="image-sec animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/bicycle/cy-3.jpg" className="full-width" alt="img"/> </Link> </div>
                <div className="bicycle-grid-caption padding-20 bg-custom-white p-relative">
                  <h4 className="title fs-16"><Link to="#" className="text-custom-black">Road Bicycle<small className="text-light-dark">2 Day</small></Link></h4>
                  <span className="price"><small>From</small>$18</span>
                  <div className="action"> <Link className="btn-second btn-small" to="#">View</Link> <Link className="btn-first btn-submit" to="#">Book</Link> </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <nav>
              <ul className="pagination justify-content-center">
                <li className="page-item"><Link className="page-link" to="#">Previous</Link></li>
                <li className="page-item"><Link className="page-link" to="#">1</Link></li>
                <li className="page-item active"><Link className="page-link" to="#">2</Link></li>
                <li className="page-item"><Link className="page-link" to="#">3</Link></li>
                <li className="page-item"><Link className="page-link" to="#">Next</Link></li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </section>
    </div>
  )
}

export default Bicycle